import { Component, OnInit } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  anio: number = new Date().getFullYear();

  constructor() { }

  ngOnInit(): void {
  }

}
